import {
  maxLength,
  pattern,
  Patterns,
  requiredNonEmptyString,
  WatchedFunction,
} from "component-library";

import {
  validateAmountOfSplitValues,
  validateSplitStringItemsLength,
  validateSplitStringOfEmails,
} from "shared/utils/form/validators/string-split-validatior";

export const MAX_MESSAGE_LENGTH = 10000;

export const MAX_EMAIL_LENGTH = 254;

export const MAX_NAME_LENGTH = 250;

export const MAX_SUBJECT_LENGTH = 500;

export const MAX_RECIPIENTS_COUNT = 500;

export interface IEmailFormContent {
  emailFormSenderNameLabel: string;
  emailFormSenderNameRequired: string;
  emailFormSenderNameMaxLength: string;
  emailFormSenderEmailLabel: string;
  emailFormSenderEmailRequired: string;
  emailFormSenderEmailValidEmail: string;
  emailFormSenderEmailMaxLength: string;
  emailFormRecipientsLabel: string;
  emailFormRecipientsRequired: string;
  emailFormRecipientsSingleMaxLength: string;
  emailFormRecipientsSingleValid: string;
  emailFormRecipientsMaxCount: string;
  emailFormSubjectLabel: string;
  emailFormSubjectRequired: string;
  emailFormSubjectMaxLength: string;
  emailFormMessageLabel: string;
  emailFormAdditionalText: string;
}

export interface IEmailForm {
  message: string;
  subject: string;
  recipients: string;
  senderName: string;
  senderEmail: string;
}

export type IEmailFormValidation = {
  [T in keyof IEmailForm]: {
    invalid: boolean;
    validationMessage: string;
  };
};

export const VALIDATE = new WatchedFunction(() => undefined);

export const GET_VALIDATION_DEFAULT = () => ({
  invalid: false,
  validationMessage: "",
});

export const getValidationFunction = (content: IEmailFormContent) => {
  return {
    message: [],
    subject: [
      requiredNonEmptyString(content.emailFormSubjectRequired),
      maxLength(
        MAX_SUBJECT_LENGTH,
        content.emailFormSubjectMaxLength.replace(
          "{maxLength}",
          `${MAX_SUBJECT_LENGTH}`
        )
      ),
    ],
    recipients: [
      requiredNonEmptyString(content.emailFormRecipientsRequired),
      validateAmountOfSplitValues(
        MAX_RECIPIENTS_COUNT,
        content.emailFormRecipientsMaxCount
      ),
      validateSplitStringItemsLength(
        MAX_EMAIL_LENGTH,
        content.emailFormRecipientsSingleMaxLength
      ),
      validateSplitStringOfEmails(content.emailFormRecipientsSingleValid),
    ],
    senderName: [
      requiredNonEmptyString(content.emailFormSenderNameRequired),
      maxLength(
        MAX_NAME_LENGTH,
        content.emailFormSenderNameMaxLength.replace(
          "{maxLength}",
          `${MAX_NAME_LENGTH}`
        )
      ),
    ],
    senderEmail: [
      requiredNonEmptyString(content.emailFormSenderEmailRequired),
      pattern(Patterns.email, content.emailFormSenderEmailValidEmail),
      maxLength(
        MAX_EMAIL_LENGTH,
        content.emailFormSenderEmailMaxLength.replace(
          "{maxLength}",
          `${MAX_EMAIL_LENGTH}`
        )
      ),
    ],
  };
};
